import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import VueMeta from "vue-meta";
import VueLazyload from "vue-lazyload";
import infiniteScroll from "vue-infinite-scroll";
import "./assets/tailwind.css";

Vue.use(VueMeta, {
  refreshOnceOnNavigation: true,
});

// Optimized lazy loading configuration
Vue.use(VueLazyload, {
  preLoad: 1.5, // Load images that are 1.5 viewport heights ahead
  attempt: 1,  // Number of attempts before displaying error state
  observer: true, // Use Intersection Observer API for better performance
  observerOptions: {
    rootMargin: '200px', // Start loading 200px before image enters viewport
    threshold: 0.1
  },
  // Only listen for necessary events to improve performance
  listenEvents: ['scroll', 'wheel', 'resize', 'orientationchange'],
});

Vue.use(infiniteScroll);
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
